module.exports = __webpack_public_path__ + "static/preview-3-d9afa141615536566c3aca2bd5878aa7.png";